<template lang="pug">
  .plan-reservation-rates

    plan-reservation-rate(v-for="rate in planRates", :item="rate", type="listing", @deleted="load")

</template>
<script type="text/babel">

  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import PlanReservationRate from "../PlanReservationRate.vue";


  export default {
    name: "PlanReservationRates",
    components: {PlanReservationRate},
    data() {
      return {
        planRates: null
      }
    },
    created() {
      this.load()
    },
    methods: {
      load() {
        KeplerBackofficeSdk.plans.select(this.$route.params.id).rates((data) => {
          this.planRates = data
        })
      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// PlanReservationRates.vue?0ad9142c